export default __webpack_public_path__ + "static/media/Short Sea Shipping.26ec07d4.svg";